import { Panel } from "@src/features/experienceBuilder/modifications/common/panel/Panel";

import { InputProps } from "./types";
import { useValidatedInput } from "./useValidatedInput";

const NUMBER_REGEX = /^-?\d*(\.\d*)?$/;

export const NumberInput = ({ label, value, onChange }: InputProps) => {
  const field = useValidatedInput(value, onChange, (v) => NUMBER_REGEX.test(v));

  return <Panel.TextField label={label} {...field} />;
};
